<template>
  <div style="padding-top: 120px" class="container-flight margin_container_hf">
    <PDKModal :buttonObject="modalButtonProps" v-if="showTimerModal" @btnAction="goToSearch">
      <div style="text-align: center" slot="body">
        <img id="timer-logo" width="150" height="150" src="../../../public/img/out-of-ti.png" />
        <h4 style="margin-top: 10px"> {{ $t("SearchResults.ConfirmTimeExpired") }} </h4>
      </div>
    </PDKModal>

    <PDKSpinner v-if="showCreditSpinner" />

    <div v-if="!showCreditSpinner">
      <div class="search-box">
        <HotelSearch :hotelList="hotelList" :cityList="cityList" />
      </div>
      <div>
        <h3 style="color: #08446a"><i class="icon-info-1"></i> {{ $t("SearchResults.HotelInformation") }}</h3>
      </div>
      <div class="row">
        <div class="col-md-5">
          <PdkSelectedRoom style="min-height: 320px !important" :hotelDetail="hotelInfo"
            :selectedRoom="bookingDetail.hotel" />
        </div>
        <div class="col-md-7">
          <div class="room-box">
            <div style="padding: 0px 12px 0px 0px" class="row">
              <div class="col-md-6 col-xs-6">
                <div class="row" style="height=400px">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3550.22295840926!2d56.1039550154743!3d27.1492743564009!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef8295a634c6c17%3A0xdd3bc1a40efd7b4!2z2YfYqtmEINiv2KfYsduM2YjYtA!5e0!3m2!1sen!2s!4v1614582465972!5m2!1sen!2s"
                    width="400" height="400" style="border: 0" allowfullscreen="" loading="lazy"></iframe>
                </div>
              </div>
              <div class="col-md-6 col-xs-6">
                <p class="hotel-detail">
                  {{ $t("SearchResults.AboutHotelDariushDescription") }} 
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <h3 style="color: #08446a">
          <i class="icon-users-1"></i>{{ $t("SearchResults.PassengersInfo") }} 
        </h3>
      </div>
      <div class="cart-section">
        <table class="rwd-table">
          <thead>
            <tr class="rwd-table-header">
              <th></th>
              <th>{{ $t("SearchResults.NameAndLastname") }} </th>
              <!-- <th >
							نام و نام خانوادگی لاتین 
							</th> -->
              <th>{{ $t("Sex") }} </th>
              <th>{{ $t("BirthDate") }}</th>
              <th>{{ $t("Country") }}</th>
              <th>{{ $t("NationalCode") }} / {{ $t("Passport") }}</th>

              <th>
                <a class="edit_passengers" @click="goBack()">{{ $t("Edit") }}</a>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(passenger, index) in bookingDetail.passengers" :key="index">
              <td data-th="سن" v-if="passenger.ageType === 'ADL'">
                <i style="color: #acacac" class="icon-adult"></i>
                {{ $t("FastTrack.Adult") }}
              </td>
              <td data-th="سن" v-if="passenger.ageType === 'CHL'">
                <i style="color: #acacac" class="icon-child"></i>
                {{ $t("FastTrack.Child") }}
              </td>
              <td data-th="سن" v-if="passenger.ageType === 'INF'">
                <i style="color: #acacac" class="icon-guest"></i>
                {{ $t("FastTrack.Infant") }}
              </td>
              <td :data-th='$t("SearchResults.NameAndLastname")' v-if="passenger.nationalityId === 1">
                <strong>{{ passenger.persianName }}&nbsp;{{
                    passenger.persianFamily
                }}</strong>
              </td>
              <td :data-th='$t("SearchResults.NameAndLastname")' v-else>
                <strong>{{ passenger.englishName }}&nbsp;{{
                    passenger.englishFamily
                }}</strong>
              </td>

              <td :data-th='$t("Sex")' v-if="passenger.genderId === 1">{{ $t("Male") }}</td>
              <td :data-th='$t("Sex")' v-else>{{ $t("Female") }}</td>
              <td :data-th='$t("Sex")'>
                <strong>{{ passenger.birthDate }}</strong>
              </td>
              <td :data-th='$t("Country")' class="options">
                <strong v-if="passenger.nationalityId === 1">{{ $t("HomeHeader.Iranian") }}</strong>
                <strong v-else>{{ $t("HomeHeader.NonIranian") }}</strong>
              </td>
              <td :data-th='$t("NationalCode")  / $t("Passport")' class="options">
                <strong>{{ passenger.nationalCode }}</strong>
              </td>
              <td :data-th= '$t("Edit")' ></td>
            </tr>
          </tbody>
        </table>
        <div class="customer_request">
          <strong style="color: #08446a; margin-left: 5px">{{ $t("SearchResults.PassengerRequest") }}:</strong>
          <span>{{ bookingDetail.guestRequest }}</span>
        </div>

        <!-- <div v-if="bookingDetail.transferModel"> -->
        <div v-if="
          Object.keys(bookingDetail.transferModel).length > 0 &&
          bookingDetail.hasTransferModel
        " style="margin-top: 45px">
          <div>
            <h3 style="color: #08446a">
              <i class="icon-bus"></i>{{ $t("SearchResults.TransferInformation") }}
               </h3>
          </div>
          <table class="rwd-table">
            <thead>
              <tr class="rwd-table-header">
                <th>{{ $t("SearchResults.TravelVehicle") }}</th>
                <th>{{ $t("SearchResults.TravelDate") }}</th>
                <th>{{ $t("SearchResults.TravelTime") }}</th>
                <th>{{ $t("SearchResults.TravelDescription") }}</th>
                         <th>{{ $t("SearchResults.TravelDate") }}</th>
                <th>{{ $t("SearchResults.TravelTime") }}</th>
                <th>{{ $t("SearchResults.TravelDescription") }}</th>
                <th><a class="edit_passengers" @click="goBack()">{{ $t("Edit") }}</a></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-th='$t("SearchResults.TravelVehicle") ' v-if="bookingDetail.transferModel.transportVehicle === 1">
                  {{ $t("SearchResults.Airline") }}
                </td>
                <td data-th='$t("SearchResults.TravelVehicle") ' v-else>{{ $t("SearchResults.Train") }}</td>
                <td data-th='$t("SearchResults.TravelDate") '>
                  <strong>{{ bookingDetail.transferModel.leaveDate }}</strong>
                </td>
                <td data-th='$t("SearchResults.TravelTime") '>
                  <strong>{{ bookingDetail.transferModel.leaveTime }}</strong>
                </td>
                <td data-th='$t("SearchResults.TravelDescription") '>
                  <strong>{{
                      bookingDetail.transferModel.leaveDescription
                  }}</strong>
                </td>
                <td data-th='$t("SearchResults.ReturnDate") '>
                  <strong>{{ bookingDetail.transferModel.returnDate }}</strong>
                </td>
                <td data-th='$t("SearchResults.ReturnTime") '>
                  <strong>{{ bookingDetail.transferModel.returnTime }}</strong>
                </td>
                <td data-th='$t("SearchResults.ReturnDescription") '>
                  <strong>{{
                      bookingDetail.transferModel.returnDescription
                  }}</strong>
                </td>
                <td data-th='$t("Edit") '></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style="margin-top: 40px">
          <h3 style="color: #08446a">
            <i class="icon-money-1"></i>{{ $t("SearchResults.PriceDetails") }}
          </h3>
        </div>
        <div style="display: flex" class="cart-section">
          <table class="rwd-table">
            <thead>
              <tr class="rwd-table-header">
                <th>{{ $t("HomeHeader.Room") }}</th>
                <th>{{ $t("SearchResults.PerEachNight") }}</th>
                <th>{{ $t("SearchResults.ExtraBed") }}</th>
                <th>{{ $t("SearchResults.ChildExtraBed") }}</th>
                <!-- <th>
								جمع 
							</th> -->
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in roomsPriceDetail" :key="index">
                <td data-th='$t("HomeHeader.Room")'>
                  <strong>{{ item.roomName }}</strong>
                </td>
                <td data-th='$t("SearchResults.PerEachNight")' class="td_container">
                  <strong id="rack_price">{{
                      item.rackPrice | numFormat
                  }}</strong>
                  <strong id="normal_price">{{
                      item.price | numFormat
                  }}</strong>
                </td>

                <td data-th='$t("SearchResults.ExtraBed")' v-if="item.extraBedPrice > 0">
                  <div class="td_container">
                    <strong id="rack_price">{{
                        item.rackExtraBedPrice | numFormat
                    }}</strong>
                    <strong id="normal_price">{{
                        item.roomExtraBedPrice | numFormat
                    }}</strong>
                  </div>
                </td>
                <td data-th='$t("SearchResults.ExtraBed")' v-else><strong>0</strong></td>

                <td data-th='$t("SearchResults.ChildExtraBed")'  class="td_container" v-if="item.childWithPrice > 0">
                  <div class="td_container">
                    <strong id="rack_price">{{
                        item.rackChildPrice | numFormat
                    }}</strong>
                    <strong id="normal_price">{{
                        item.childPrice | numFormat
                    }}</strong>
                  </div>
                </td>
                <td data-th='$t("SearchResults.ChildExtraBed")'  v-else><strong>0</strong></td>
                <!-- 
 <td>
								<strong>{{item.totalRackPrice  | numFormat }}</strong>
								

							</td> -->
              </tr>
            </tbody>
          </table>
        </div>

        <div class="cart-options clearfix">
          <div class="float-left">
            <!-- <div class="apply-coupon">
							<div class="form-group">
								<input type="text" name="coupon-code" value="" placeholder="Your Coupon Code" class="form-control">
							</div>
							<div class="form-group">
								<button type="button" class="btn_cart_outine">Apply Coupon</button>
							</div>
						</div> -->
          </div>
        </div>
        <br />
        <div class="row justify-content-end">
          <div style="font-size: 16px" class="column col-lg-6 col-md-6">
            <div style="line-height: 2; margin-bottom: 30px" class="totals-table">
              <div class="clearfix">
                <span class="col"> {{ $t("TotalPrice") }} : </span><span style="text-decoration: line-through; font-weight: bold"
                  class="col">{{ packageTotalRackPrice | numFormat | rial }}</span>
              </div>
              <div class="clearfix total">
                <span class="col">{{ $t("SearchResults.AmountPayable") }}  :</span><span style="font-weight: bold" class="col">{{
                    packageTotalPrice | numFormat | rial
                }}</span>
              </div>
            </div>
            <div class="role-text">
              <input :disabled="isDisableRoleCheck" v-model="roleChecked" type="checkbox" />
              &ensp;
              <label><a href="#role-dialog" id="role_link" style="cursor: pointer !important" class="role"><span
                    style="cursor: pointer !important">{{ $t("TermsAndConditions") }}</span>
                </a>
                {{ $t("SearchResults.AcceptIt") }}.</label>
            </div>

            <div class="radios">
              <div class="radio">
                <input type="radio" id="bank" :value="false" v-model="isCredit" checked />
                <label for="bank">
                  <div class="checker"></div>
                   {{ $t("SearchResults.OnlinePayment") }}.
                </label>
              </div>

              <div class="radio">
                <input :disabled="isDisableCreditChecked" type="radio" id="credit" :value="true" v-model="isCredit"
                  name="radio" />
                <label for="credit">
                  <div class="checker"></div>
                  <span>
                    {{ $t("SearchResults.PaymentFromCredit") }}
                    <span style="color: #08446a; font-weight: bold">( <span>{{ deposit | numFormat }}</span>
                       {{ $t("SearchResults.Rial") }})</span>
                  </span>
                </label>
              </div>
            </div>
            <div v-if="isDisableTimer">
              <button style="width: 100%; width: 75%; margin-right: 14%" disabled class="btn btn-primary">
                <span v-show="!isLoading">{{ $t("SearchResults.PayAndReserve") }} <i class="icon-left"></i></span>
                <span v-show="isLoading">{{ $t("FastTrack.InProgress") }} ... <i class="fa fa-spinner fa-pulse"></i></span>
              </button>
            </div>
            <div v-else>
              <button style="width: 100%; width: 75%; margin-right: 14%" @click="book" :disabled="isDisableButton"
                class="btn btn-primary">
                <span v-show="!isLoading">{{ $t("SearchResults.PayAndReserve") }} <i class="icon-left"></i></span>
                <span v-show="isLoading">{{ $t("FastTrack.InProgress") }} ... <i class="fa fa-spinner fa-pulse"></i></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Role :roleType="'hotel'" :hotelDetail="hotelInfo" />
    </div>

  </div>
</template>


<script>
import PdkSelectedRoom from "@/components/tour/SelectedRoom";

import Role from "@/components/tour/PDKRoles";

import moment from "moment";
import dateUtil from "../../utils/date";
import Store from "./store/index";
import PDKModal from "@/components/PDKAlertModal";
import PDKSpinner from "../../components/PDKReserveSpinner";
import HotelSearch from "../../components/hotel/HotelSearch";
import jalaaliMoment from "moment-jalaali";

import $ from "jquery";

// import Vue from "vue";

require("linqjs");

export default {
  store: Store,
  provide() {
    return {
      //   forms: Vue.computed(() => this.forms),
    };
  },
  components: { PDKSpinner, Role, PdkSelectedRoom, PDKModal, HotelSearch },
  data() {
    return {
      showCreditSpinner: false,
      hotelInfo: {},
      isDisableTimer: false,
      hotelList: [],
      cityList: [],
      isDisableCreditChecked: false,
      deposit: 0,
      reserveNo: "",
      isCredit: false,
      isDisableButton: false,
      isDisableRoleCheck: false,
      isLoading: false,
      roleChecked: false,
      totalNight: 0,
      passengers: [],
      passengerForm: [],
      modalButtonProps: {
        title: "جستجوی مجدد",
      },
      showTimerModal: false,
      roomsPriceDetail: [],
      searchItems: {},
      params: {},

      bookingDetail: {},
    };
  },
  watch: {
    roleChecked: function (val) {
      if (val === true && this.packageTotalPrice > 0) {
        this.isDisableButton = false;
      } else {
        this.isDisableButton = true;
      }
    },
    isLoading: function (val) {
      if (val === true) {
        this.isDisableButton = true;
        this.isDisableRoleCheck = true;
      } else {
        this.isDisableRoleCheck = false;
        this.isDisableButton = false;
      }
    },
  },
  created() {
    this.getLocationList();
    // this.getHotelList();
    if (this.roleChecked === false) {
      this.isDisableButton = true;
    }
    this.params = this.$route.query;
    this.hotelInfo = this.$store.getters["hotel/GetHotelDetails"];

    if (!Object.keys(this.hotelInfo).length) {
      this.goToSearch();
    }

    this.getSearchItems();
    this.bookingDetail = this.$store.getters["hotel/GetHotelBookingDetails"];

    if (this.bookingDetail.hasTransferModel) {
      this.bookingDetail.transferModel.returnDate = dateUtil.ConvertToPersian(
        new Date(this.bookingDetail.transferModel.returnDate)
      );
      this.bookingDetail.transferModel.leaveDate = dateUtil.ConvertToPersian(
        new Date(this.bookingDetail.transferModel.leaveDate)
      );
    }
    this.getCredit();
    var x = setTimeout(() => {
      this.isDisableTimer = true;
      this.endTimeCountdown();
    }, 600000);
    this.totalRoomPriceDetail();
  },
  computed: {
    packageTotalPrice() {
      var roomPrice = this.calcRoomTotalPrice(this.bookingDetail.hotel);
      this.totalNight = this.calculateTotalNight();

      var totalRoom = roomPrice * this.totalNight;

      return totalRoom;
    },
    roomTotalPrice() {
      return this.calcRoomTotalPrice(this.bookingDetail.hotel);
    },
    packageTotalRackPrice() {
      var roomPrice = this.calcRoomTotalRackPrice(this.bookingDetail.hotel);
      this.totalNight = this.calculateTotalNight();

      var totalRoom = roomPrice * this.totalNight;

      return totalRoom;
    },
    roomTotalRackPrice() {
      return this.calcRoomTotalRackPrice(this.bookingDetail.hotel);
    },
  },
  methods: {
    calcRoomTotalRackPrice: function (rooms) {
      return rooms.reduce((acc, val) => {
        return acc + parseInt(val.totalBasePrice);
      }, 0);
    },
    totalRoomPriceDetail() {
      this.bookingDetail.hotel.forEach((element) => {
        var res = this.roomPriceDetail(element);

        this.roomsPriceDetail.push(res);
      });
    },
    roomPriceDetail(room) {
      var noneFreeInfant = 0;
      var noneFreeChild = 0;
      var nOchild = room.numberOfChild;
      if (room.numberOfInfant > 1) {
        noneFreeInfant = room.numberOfInfant - 1;
      } else {
        noneFreeInfant = 0;
      }

      if (noneFreeInfant >= 1 && room.numberOfForFreeChild == 0) {
        room.numberOfForFreeChild = room.numberOfForFreeChild + 1;
        noneFreeInfant = noneFreeInfant - 1;
      }

      if (room.numberOfForFreeChild > 0 && nOchild == 0) {
        nOchild = room.numberOfForFreeChild;
      }
      if (room.numberOfForFreeChild > 1) {
        noneFreeChild = room.numberOfForFreeChild - 1;
      } else {
        noneFreeChild = 0;
      }

      var childPriceCount = noneFreeInfant + noneFreeChild;
      const pax = room.numberOfAdult + childPriceCount;
      const bedsCount = room.capacity;
      const extrabed = room.maximumExtraBed;
      const capacity = pax - bedsCount;
      const basePrice = room.basePrice;
      const discount = room.discount;

      var selectedExtraBed = 0;
      var childPrice = 0;
      var rackChildPrice = 0;

      var extraBedPrice = 0;
      var rackExtraBedPrice = 0;

      if (capacity > 0 && extrabed > 0) {
        selectedExtraBed = capacity;

        if (childPriceCount === selectedExtraBed) {
          childPrice = room.childPrice * childPriceCount;
          rackChildPrice = room.rackChildPrice * childPriceCount;
          extraBedPrice = 0;
        } else {
          if (childPriceCount > selectedExtraBed) {
            childPrice = room.childPrice * (childPriceCount - selectedExtraBed);
            rackChildPrice =
              room.rackChildPrice * (childPriceCount - selectedExtraBed);
          } else if (
            childPriceCount < selectedExtraBed &&
            childPriceCount > 0
          ) {
            childPrice = room.childPrice * childPriceCount;
            rackChildPrice = room.rackChildPrice * childPriceCount;

            extraBedPrice =
              room.extraBedPrice * (selectedExtraBed - childPriceCount);
            rackExtraBedPrice =
              room.rackExtraBedPrice * (selectedExtraBed - childPriceCount);
          } else if (
            childPriceCount < selectedExtraBed &&
            childPriceCount === 0 &&
            nOchild == 0
          ) {
            extraBedPrice = room.extraBedPrice * selectedExtraBed;
            rackExtraBedPrice = room.rackExtraBedPrice * selectedExtraBed;
          }
        }
      }
      var total = basePrice - discount + childPrice + extraBedPrice;
      var totalRackPrice = basePrice + rackChildPrice + rackExtraBedPrice;

      room.numberOfExtraBed = selectedExtraBed;
      var roomPrice = {
        totalRackPrice: totalRackPrice,
        totalRoomPrice: total,
        numberOfExtraBed: selectedExtraBed,
        extraBedPrice: extraBedPrice,
        roomExtraBedPrice: room.extraBedPrice,
        rackExtraBedPrice: room.rackExtraBedPrice,
        price: basePrice - discount + childPrice,
        rackPrice: basePrice,
        rackChildPrice: room.rackChildPrice,
        childPrice: room.childPrice,
        roomName: room.name,
        adult: room.numberOfAdult,
        child: room.numberOfChild,
        infant: room.numberOfInfant,
        childWithPrice: room.childWithPrice,
      };
      return roomPrice;
    },

    goBack() {
      this.$router.go(-1);
    },
    async getCredit() {
      var deposit = this.$store.getters.GetSelectedSourceDeposit;
      this.deposit = deposit;

      if (deposit < this.packageTotalPrice) {
        this.isDisableCreditChecked = true;
      }
    },
    async getLocationList() {
      this.cityList = await this.$store.dispatch("getLocations");
      this.cityList = this.cityList.filter(
        (p) =>
          p.type == "City" &&
          (p.iata == "KIH" || p.iata == "MHD" || p.iata == "SYZ")
      );
    },
    // async getHotelList() {
    //   const hotelList = await this.$store.dispatch("getHotelList");

    //   if (Array.isArray(hotelList)) {
    //     this.mapHotelData(hotelList);
    //   }
    // },
    // async getCredit(){
    //   debugger;
    //   var res= await this.$store.dispatch(
    //     "Book/GetCredit",
    //     this.bookingDetail
    //   );
    //   if (res) {
    //      console.log('res this.packageTotalPrice' , this.packageTotalPrice);

    //     if( res.deposit < this.packageTotalPrice) {
    //       this.isDisableCreditChecked = true;
    //     }
    //     this.deposit = res.deposit;
    //   }
    // },
    async book() {
      this.isLoading = true;

      this.bookingDetail.packageTotalPrice = this.packageTotalPrice;
      if (this.isCredit === true) {
        this.showCreditSpinner = true;
        var res = await this.$store.dispatch(
          "hotel/CreditBook",
          this.bookingDetail
        );
debugger
        if (res) {
          if (res.result === 1) {
            this.reserveNo = res.data.reserveNumber;
          } else {
            this.reserveNo = res.result;
          }

          this.$router.push({
            path: "ticket",
            name: "hotelticket",
            query: {
              id: this.reserveNo,
            },
          });
        }
      } else {
        var res = await this.$store.dispatch(
          "hotel/Reserve",
          this.bookingDetail
        );
        if (res) {
          if (res.result === 1) {
            this.$router.push({
              path: "payment",
              name: "hotelPayment",
              query: {
                refrence: res.data.bankRefrenceId,
              },
            });
          } else {
            this.$router.push({
              path: "error",
              name: "HotelError",
              query: {
                id: res.result,
              },
            });
          }
        }
      }
    },
    calculateTotalNight() {
      var fromDate = dateUtil.ConvertToPersian(this.params.startDate);
      var toDate = dateUtil.ConvertToPersian(this.params.endDate);
      if (
        fromDate !== "" &&
        fromDate !== null &&
        toDate !== "" &&
        toDate !== null
      ) {
        //  var diff = moment(toDate).diff(moment(fromDate), "days");
        let fDate = this.params.startDate;
        let tDate = this.params.endDate;
        var startDate = moment(fDate);
        var endDate = moment(tDate);
        let duration = moment.duration(endDate.diff(startDate));

        let diff = Math.round(duration.asDays());
        // var diff = moment(tDate).diff(moment(fDate), "days");

        return diff;
      } else {
        return 0;
      }
    },

    calcRoomTotalPrice: function (rooms) {
      return rooms.reduce((acc, val) => {
        return acc + parseInt(val.totalFarePrice);
      }, 0);
    },
    goToSearch() {
      const request = {
        hotelId: this.params.hotelId,
        startDate: this.params.startDate,
        endDate: this.params.endDate,
        city: this.params.city,
        rooms: this.params.rooms,
      };

      this.$router
        .push({
          name: "hotelrooms",
          query: request,
        })
        .catch(() => {});
    },
    endTimeCountdown() {
      this.showTimerModal = true;
    },

    getSearchItems() {
      var rooms = JSON.parse(this.params.rooms);

      var pax = 0;
      var fromDate = dateUtil.ConvertToPersian(this.params.fromDate);
      var toDate = dateUtil.ConvertToPersian(this.params.toDate);
      var totalChild = 0;

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age >= 2) {
            totalChild = totalChild + 1;
          }
        });
      });

      var totalInfant = 0;

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age < 2) {
            totalInfant = totalInfant + 1;
          }
        });
      });

      var totalAdult = rooms.sum((t) => t.adults);

      this.searchItems = {
        origin: this.params.originName,
        destination: this.params.destinationName,
        fromDate: fromDate,
        toDate: toDate,
        pax: totalAdult + totalChild + totalInfant,
        rooms: rooms,
        roomsCount: rooms.length,
      };
    },
  },
  mounted() {
    require("magnific-popup");
    $(this.$el.querySelector("#role_link")).magnificPopup({
      type: "inline",
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: "my-mfp-zoom-in",
    });
  },
};
</script>
<style lang="scss" scoped>
.rwd-table {
  width: 100%;
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table-header {
  border-top: none;
  background: #ffffff !important;
  color: #0c3a50;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f7f7f7;
}

.rwd-table tr th {
  text-align: right;
}

.rwd-table tr td {
  text-align: right;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: 0.5em;
}

.rwd-table td:last-child {
  margin-bottom: 0.5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table {
  color: #333;
  border-radius: 0.4em;
  overflow: hidden;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: 0.5em 1em;
}

@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
}

@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }

  .rwd-table td:before {
    display: none;
  }

  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: 0.25em 0.5em;
  }

  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }

  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }

  .rwd-table th,
  .rwd-table td {
    padding: 1em !important;
  }
}

.role {
  color: #0a6c9f !important;
  font-weight: bold;
  cursor: pointer !important;
}

.custom_form_title h3 strong {
  margin-top: -4px !important;
  margin-right: 3px !important;
  height: 35px !important;
  width: 35px !important;
  background-color: #bdc6cb !important;
}

.custom_form_title {
  margin-bottom: 0px !important;
  padding-right: 45px !important;
}

.custom_row {
  margin-top: 50px;
}

.styled-select {
  background-color: white !important;
  border: 1px solid #ced4da !important;
}

.role-text {
  margin-bottom: 20px;
}

.radios {
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 640px) {
    flex-direction: column;
  }
}

.radio {
  input {
    position: absolute;
    pointer-events: none;
    visibility: hidden;
  }

  .search-box {
    position: relative;
    z-index: 9999;
    padding-bottom: 40px;
  }

  input:focus + label {
    background: #eeeeff;

    .checker {
      border-color: #6666ff;
    }
  }

  input:checked + label {
    .checker {
      box-shadow: inset 0 0 0 6px #6666ff;
      margin-left: 4px;
    }
  }

  label {
    display: flex;
    align-items: center;
    height: 28px;
    border-radius: 14px;
    margin: 10px;
    padding: 0 8px 0 6px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background: #eeeeff;

      .checker {
        box-shadow: inset 0 0 0 2px #6666ff;
      }
    }
  }

  .checker {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-right: 8px;
    box-shadow: inset 0 0 0 2px #ccc;
    transition: box-shadow 0.3s ease;
    margin-left: 4px;
  }

  .room-box {
    min-height: 320px !important;
    padding: 20px;
    position: relative;
    background: #fff;
    margin-bottom: 30px;
    color: #888;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
    border-radius: 15px;
  }
}

.customer_request {
  margin-top: 50px;
  text-align: initial;
  font-size: 14px;
  padding: 15px 5px 15px 5px;
  background: #fbfdff;
}

.edit_passengers {
  color: #0a6c9f !important;
  cursor: pointer;
}

.td_container {
  display: inline-grid;
  font-size: 15px;
}

.td_container #rack_price {
  text-decoration: line-through;
}

.td_container #normal_price {
}
</style>